import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    backgroundColor: colors.primaryBackground,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '64px 80px',
    minHeight: '100vh',
    gap: '24px',
  },
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-24'],
    width: '280px',
    fontFamily: fonts.din2014Regular,
  },
  // Это чтобы скрыть оболочку мероприятия и открыть отправку приглашений
  mainHidden: {
    display: 'none',
  },
});
